interface SliderProps {
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  labels?: { value: number; label: string }[];
}

export function Slider({ value, min, max, onChange, labels }: SliderProps) {
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className="w-full">
      <div className="relative">
        {/* Track background with fill */}
        <div
          className="absolute top-1/2 left-0 h-2 rounded-full -translate-y-1/2"
          style={{
            width: `${percentage}%`,
            background: 'linear-gradient(90deg, var(--color-accent), var(--color-accent-light))',
          }}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="relative z-10 w-full"
        />
      </div>

      {/* Number markers */}
      <div className="flex justify-between mt-3 px-1">
        {Array.from({ length: max - min + 1 }, (_, i) => min + i).map((num) => (
          <span
            key={num}
            className={`text-sm ${num === value ? 'text-accent font-semibold' : 'text-muted'}`}
          >
            {num}
          </span>
        ))}
      </div>

      {/* Labels */}
      {labels && (
        <div className="mt-4 text-center">
          {labels.map(
            ({ value: labelValue, label }) =>
              value === labelValue && (
                <span key={label} className="text-lg text-accent font-medium">
                  {label}
                </span>
              )
          )}
        </div>
      )}
    </div>
  );
}

// Helper function to get label based on value range
export function getAttractivenessLabel(value: number): string {
  if (value <= 2) return 'Below average';
  if (value <= 4) return 'Slightly below average';
  if (value <= 6) return 'Average';
  if (value <= 8) return 'Above average';
  return 'Very attractive';
}
